import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import MaterialReactTable from 'material-react-table';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { MultiSelect } from "react-multi-select-component";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarNew from '../NewAdminPanel/Common/AdminSideBar';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { Box, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
const CompanyLogin = () => {

    const navigate = useNavigate();
    const { statelocation } = useLocation();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionCompany, setOptionCompany] = useState([]);
    const [companyValue, setCompanyValue] = useState([]);
    const [selected, setSelected] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState([]);
    const [formsData, setFormsData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [emailValue, setEmailValue] = useState("");
    const [isFetchingState, setIsFetchingState] = useState(true);
    const [mobileValue, setMobileValue] = useState("");
    const [userNameValue, setUserNameValue] = useState("");
    const [gender, setGender] = useState('');
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [userLevelValue, setUserLevelValue] = useState("");
    const [userRoleValue, setUserRoleValue] = useState("");
    const [showDistrict, setShowDistrict] = useState(false);
    const [showSubDistrict, setShowSubDistrict] = useState(false);
    const [showVillage, setShowVillage] = useState(false);
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState([]);
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState([]);
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [optionDesignaion, setOptionDesignation] = useState([]);
    const [designationValue, setDesignationValue] = useState([]);
    const [loader, setLoader] = useState(false);
    useEffect(() => {
        getStates();
        fetchDesignation();
    }, []);

    const fetchDesignation = async () => {
        const result = await axios(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/Management/commDesignation`
        );

        setOptionDesignation(result.data.dataContent);
    };

    useEffect(() => {



        if (sessionStorage.getItem("userTypeCodeModel") === "1") {


            var x = document.getElementById("userType");
            var option1 = document.createElement("option");
            option1.text = "State";
            option1.value = "2"
            x.add(option1);

            var option2 = document.createElement("option");
            option2.text = "District";
            option2.value = "3"
            x.add(option2);

            var option3 = document.createElement("option");
            option3.text = "SubDistrict";
            option3.value = "4"
            x.add(option3);



            var option5 = document.createElement("option");
            option5.text = "Surveyor";
            option5.value = "5"
            x.add(option5);


        } else if (sessionStorage.getItem("userTypeCodeModel") === "2") {

            var x = document.getElementById("userType");

            var option = document.createElement("option");
            option.text = "District";
            option.value = "3"
            x.add(option);

            var option3 = document.createElement("option");
            option3.text = "SubDistrict";
            option3.value = "4"
            x.add(option3);



            var option5 = document.createElement("option");
            option5.text = "Surveyor";
            option5.value = "5"
            x.add(option5);

        } else if (sessionStorage.getItem("userTypeCodeModel") === "3") {

            var x = document.getElementById("userType");

            var option = document.createElement("option");
            option.text = "SubDistrict";
            option.value = "4"
            x.add(option);
            var option5 = document.createElement("option");
            option5.text = "Surveyor";
            option5.value = "5"
            x.add(option5);



        } else if (sessionStorage.getItem("userTypeCodeModel") === "4") {

            var x = document.getElementById("userType");
            var option = document.createElement("option");
            option.text = "Surveyor";
            option.value = "5"
            x.add(option);

        }

        //   }

    }, [])


    useEffect(() => {

        if (isFetchingState == false) {

            handleState();
            setIsFetchingState(true);
        }

    }, [stateValue]);

    function handleResetForm() {
        setEmailValue("");
    }

    function validateEmail() {
        if (emailValue.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            document.getElementById("emailid").style.borderColor = "green";
        } else {
            document.getElementById("emailid").style.borderColor = "red";
        }
    }

    function getStates() {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            userCode: sessionStorage.getItem("userCodeModel"),
            stateCode: "",
            districtCode: "",
            subDistrictCode: "",
            villageCode: ""
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/gt/LGD_Location`,
            requestOptions
        )
            .then((response) => response.text())
            // .then((result) => setVillageData(JSON.parse(result).dataContent) {
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent;

                let myArray = [];
                localFormDataState.map((item, key) => {
                    myArray.push({ label: item.stateName, value: item.stateCode })
                })

                setOptionState(myArray)
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
    }
    function getCompany(value) {
        setStateValue('');

        if (sessionStorage.getItem("orgTypeCodeModel") === "C") {
            if (value === '3' || value === '5') {
                setShowDistrict('show');
                setShowSubDistrict('hide');
                setShowVillage('hide');
                setsubDistrictValue('');
                setvillageValue('');
            }
            else {
                setShowDistrict('hide');
                setShowSubDistrict('hide');
                setShowVillage('hide');
                setsubDistrictValue('');
                setvillageValue('');
                setDistrictValue('');
            }
        }
        else {
            if (value === '3') {
                setShowDistrict('show');
                setShowSubDistrict('hide');
                setShowVillage('hide');
                setsubDistrictValue('');
                setvillageValue('');

            }
            else if (value === '4') {
                setShowDistrict('show');
                setShowSubDistrict('show');
                setShowVillage('hide');
                setvillageValue('');

            }
            else if (value === '5') {
                setShowDistrict('hide');
                setShowSubDistrict('hide');
                setShowVillage('hide');
                setsubDistrictValue('');
                setvillageValue('');
                setDistrictValue('');
            }
            else {
                setShowDistrict('hide');
                setShowSubDistrict('hide');
                setShowVillage('hide');
                setsubDistrictValue('');
                setvillageValue('');
                setDistrictValue('');
            }
        }


        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");


        var raw = JSON.stringify({
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            userTypeCode: value,
            CreatedByUC: sessionStorage.getItem("userCodeModel")

        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/PDMC/pdmcUserRole/GetPDMCRolebySchemeCode`,
            requestOptions
        )
            .then((response) => response.text())
            // .then((result) => setVillageData(JSON.parse(result).dataContent) {
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent;

                let myArray = [];
                localFormDataState.map((item, key) => {
                    myArray.push({ label: item.userRoleName, value: item.userRoleCode })
                })

                setOptionCompany(myArray)
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
    }

    let handleChange = (stateValue) => {

        setIsFetchingState(false);
        setStateValue(stateValue.map(option => option.value));

    };
    function handleUserLevel(value) {

        setUserRoleValue("")
        setUserLevelValue(value)
        getCompany(value)
    }

    function handleState() {
        setOptionDistrict([]);
        if (stateValue.length != 0) {

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let stateValueData = "";

            stateValue.map((item) => {
                stateValueData = stateValueData + item + ","
            })

            stateValueData = stateValueData.slice(0, -1);
            var raw = JSON.stringify({
                userCode: sessionStorage.getItem("userCodeModel"),
                stateCode: stateValueData.toString(),
                districtCode: "",
                subDistrictCode: "",
                villageCode: ""
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/gt/LGD_Location`,
                requestOptions
            )


                .then((response) => response.text())
                .then((result) => {
                    let localFormDataDistrict = JSON.parse(result).dataContent;

                    let myArrayDistrict = [];
                    localFormDataDistrict.map((item, key) => {
                        myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                    })

                    setOptionDistrict(myArrayDistrict)
                    setIsFetching(false);
                })
                .catch((error) => console.log("error", error));
        }
    }

    let handleChangeDistrict = (districtValue) => {
        setOptionSubDistrict([]);
        setDistrictValue(districtValue.map(option => option.value));
        setselectedDataSetDistrict(districtValue.map(item => `${item.stateid}|${item.value}`).join(','));

        let stateValueData = "";

        stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        if (districtValue.length != 0) {

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            let districtValueData = "";
            districtValue.map((item) => {
                districtValueData = districtValueData + item.value + ","
            })

            districtValueData = districtValueData.slice(0, -1);


            var raw = JSON.stringify({
                userCode: sessionStorage.getItem("userCodeModel"),
                stateCode: stateValueData.toString(),
                districtCode: districtValueData.toString(),
                subDistrictCode: "",
                villageCode: ""
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/gt/LGD_Location`,
                requestOptions
            )


                .then((response) => response.text())
                .then((result) => {
                    let localFormDataSubDistrict = JSON.parse(result).dataContent;

                    let myArraySubDistrict = [];
                    localFormDataSubDistrict.map((item, key) => {
                        myArraySubDistrict.push({ label: item.subDistrictName, value: item.subDistrictCode, districtCode: item.districtCode })
                    })

                    setOptionSubDistrict(myArraySubDistrict)
                    setIsFetching(false);
                })
                .catch((error) => console.log("error", error));

        }
    };


    let handleChangeSubDistrict = (subdistrictValue) => {
        setOptionVillage([]);
        setsubDistrictValue(subdistrictValue.map(option => option.value));
        setselectedDataSetSubDistrict(subdistrictValue.map(item => `${item.districtCode}|${item.value}`).join(','));

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        let stateValueData = "";

        stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        let districtValueData = "";
        districtValue.map((item) => {
            districtValueData = districtValueData + item + ","
        })

        let subdistrictValueData = "";
        subdistrictValue.map((item) => {
            subdistrictValueData = subdistrictValueData + item.value + ","
        })


        if (subdistrictValue.length != 0) {

            var raw = JSON.stringify({
                userCode: sessionStorage.getItem("userCodeModel"),
                stateCode: stateValueData.toString(),
                districtCode: districtValueData.toString(),
                subDistrictCode: subdistrictValueData.toString(),
                villageCode: ""
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/gt/LGD_Location`,
                requestOptions
            )


                .then((response) => response.text())
                .then((result) => {
                    let localFormDataVillage = JSON.parse(result).dataContent;

                    let myArrayVillage = [];
                    localFormDataVillage.map((item, key) => {
                        myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                    })

                    setOptionVillage(myArrayVillage)
                    setIsFetching(false);
                })
                .catch((error) => console.log("error", error));

        }


    };

    let handleChangeVillage = (villageValue) => {

        setvillageValue(villageValue.map(option => option.value));
        setselectedDataSetVillage(villageValue.map(item => `${item.subDistrictCode}|${item.value}`).join(','));

    };



    let handleCompany = (companyValue) => {

        setCompanyValue(companyValue);
        //  if (sessionStorage.getItem("orgTypeCodeModel") === "G") {
        if (companyValue === "63" && userLevelValue == "5" || companyValue === "64" && userLevelValue == "5") {
            setShowDistrict('show');
            setShowSubDistrict('hide');
            setShowVillage('hide');
        }
        else if (companyValue === "62" && userLevelValue == "5" || companyValue === "61" && userLevelValue == "5") {
            setShowDistrict('hide');
            setShowSubDistrict('hide');
            setShowVillage('hide');
        }
        else if (companyValue === "66" && userLevelValue == "5" || companyValue === "65" && userLevelValue == "5") {
            setShowDistrict('show');
            setShowSubDistrict('show');
            setShowVillage('hide');
        }
        else if (companyValue === "55" && userLevelValue == "5" || companyValue === "60" && userLevelValue == "5") {
            setShowDistrict('show');
            setShowSubDistrict('show');
            setShowVillage('show');
        }
        else if (companyValue === "53" && userLevelValue == "3" || companyValue === "58" && userLevelValue == "3") {
            setShowDistrict('show');
            setShowSubDistrict('hide');
            setShowVillage('hide');
        }
        else if (companyValue === "54" && userLevelValue == "4" || companyValue === "59" && userLevelValue == "4") {
            setShowDistrict('show');
            setShowSubDistrict('show');
            setShowVillage('hide');
        }
        else {
            setShowDistrict('hide');
            setShowSubDistrict('hide');
            setShowVillage('hide');
        }
        //}

    };

    let handleDesignation = (designationValue) => {

        setDesignationValue(designationValue);
    }

    function handleMobileNumber(value) {
        const valueFinal = value.replace(/\D/g, "").replace(/^0/, "").replace(/^1/, "").replace(/^2/, "").replace(/^3/, "").replace(/^4/, "").replace(/^5/, "");
        setMobileValue(valueFinal)
    }

    function validateMobile() {
        // setMobileVerify(false)
        if (mobileValue.length === 10) {
            document.getElementById("mobilenumber").style.borderColor = "green";
        } else {
            document.getElementById("mobilenumber").style.borderColor = "red";
        }
    }

    function ValidateAddUser() {

        let valid = false;

        if (userLevelValue === "" || userLevelValue === "Choose..." || userLevelValue === "NA") {
            valid = false;
            alert("Select User Level")
            return;
        } else {
            valid = true
        }

        if (companyValue === "" || companyValue === "Choose..." || companyValue === "NA") {
            valid = false;
            alert("Select User Role")
            return;
        } else {
            valid = true
        }


        if (stateValue.length === 0) {
            alert("Select Any State Value")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if ((districtValue.length === 0) && showDistrict === 'show') {
            valid = false;

            alert("Select Any District")
            return;

        } else {
            valid = true;
        }

        if ((subdistrictValue.length === 0) && showSubDistrict === 'show') {
            valid = false;

            alert("Select Any Sub District")
            return;

        } else {
            valid = true;
        }

        if ((showVillage.length === 0) && showVillage === 'show') {
            valid = false;

            alert("Select Any Village")
            return;

        } else {
            valid = true;
        }

        if (userNameValue === "") {
            valid = false;
            alert("Enter Correct User Name")
            return;
        } else {
            valid = true
        }

        let matchval = emailValue.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);

        if (emailValue === "") {
            valid = false;
            alert("Enter Email")
            return;
        } else if (matchval === null) {
            valid = false;
            alert("Enter Correct Email")
            return;
        }

        else {
            valid = true
        }

        if (mobileValue === "") {
            valid = false;
            alert("Enter Mobile Number")
            return;
        } else if (mobileValue.length !== 10) {
            valid = valid = true;
            alert("Enter 10 digit Mobile Number")
            return;
        }
        else {
            valid = true
        }

        //npconsole.log("designationValue !!!!",designationValue.toString());
        if (designationValue.toString() === '' || designationValue.toString() === "Choose..." || designationValue.toString() === 'NA') {
            valid = false;
            alert("Select Designation")
            return;
        } else {
            valid = true
        }


        if (gender === "") {
            valid = false;
            alert("Select Gender")
            return;
        } else {
            valid = true
        }





        if (valid === true) {
            AddNewUser();
        }



    }
    function AddNewUser() {
        setLoader(true)
        let stateValueData = "";
        let districtValueData = "";
        let subdistrictValueData = "";
        let villageValueData = "";


        stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        stateValueData = stateValueData.slice(0, -1);

        if (selectedDataSetDistrict != "") {
            districtValueData = selectedDataSetDistrict;
        }
        if (selectedDataSetSubDistrict != "") {
            subdistrictValueData = selectedDataSetSubDistrict;
        }
        if (selectedDataSetVillage != "") {
            villageValueData = selectedDataSetVillage;
        }



        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({

            "createdByUC": sessionStorage.getItem("userCodeModel"),
            "userRoleCode": companyValue.toString(),
            "userName": userNameValue.toString(),
            "userId": mobileValue.toString(),
            "mobile": mobileValue.toString(),
            "emailId": emailValue.toString(),
            "gender": gender.toString(),
            "departmentCode": sessionStorage.getItem("departmentNameModel"),
            "designationCode": designationValue.toString(),
            "stateCode": stateValueData.toString(),
            "districtCode": districtValueData.toString(), //Number(userLevelValue) > 2 &&  districtValue !== "NA" && districtValue !== "" && districtValue !== "Choose..." ? String(districtValue) : "",
            "subDistrictCode": subdistrictValueData.toString(),// Number(userLevelValue) > 3 && subDistrictValue !== "NA" && subDistrictValue !== "" && subDistrictValue !== "Choose..." ? String(subDistrictValue) : "",
            "blockCode": "",
            "villageCode": villageValueData.toString(),// Number(userLevelValue) > 4 ? String(localVillageValue) : "",
            "userTypeCode": userLevelValue.toString(),
            "schemeCode": sessionStorage.getItem("schemeCodeModel").toString(),
            "Aadhar": "",
            "orgTypeCode": sessionStorage.getItem("orgTypeCodeModel").toString(),
            "InsuranceCompanyCode": sessionStorage.getItem("companycodeNameModel"),
            "isMobileVerified": "N",
            "isEmailVerified": "N"
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/gt/users`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    //   setFlag(true);
                    setLoader(false);
                    navigate("/newadminpanel/userlist");
                }
                else {
                    setLoader(false);
                }
            })
            .catch((error) => console.log("error", error));

    }
    function UpdateUser() {
    }

    function handleUserName(e) {
        let localText = e.target.value.replace(/[^\w\s]/gi, "")
        setUserNameValue(localText)
    }


    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'Surveyor User Name',
                header: 'Surveyor User Name',
            },
            {
                accessorKey: 'State',
                header: 'State',
            },
            {
                accessorKey: 'District',
                header: 'District',
            },
            {
                accessorKey: 'Sub-District',
                header: 'Sub-District',
            },
            {
                accessorKey: 'Mobile Number',
                header: 'Mobile Number',
            },
            {
                accessorKey: 'Father Name',
                header: 'Father Name',
            },
            {
                accessorKey: 'Aadhar Number',
                header: 'Aadhar Number',
            },
            {
                accessorKey: 'Gender',
                header: 'Gender',
            },

        ],
        [],
    );

    return (

        <>
            <AdminHeaderNew />
            <AdminSideBarNew />

            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Users Creation</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin
                            </li>
                            <li className="breadcrumb-item active">User Creation</li>
                        </ol>
                    </nav>

                </div>
                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <form className="row g-3">
                                        {(sessionStorage.getItem("orgTypeCodeModel") === "C") ? (
                                            <div className='col-md-3'>
                                                <label className="form-label">Company Name</label>
                                                <input placeholder='companyname' type='text' id="companyname" className='form-control' value={sessionStorage.getItem("orgTypeCodeNameModel")}
                                                    readOnly="true" />
                                            </div>
                                        ) : ("")}









                                        <div className='col-md-3'>
                                            <label className="form-label">User Level</label><label style={{ color: "red" }}>*</label>
                                            <select className='form-select' onChange={(e) => handleUserLevel(e.target.value)} value={userLevelValue} id="userType">
                                                <option>Choose...</option>

                                            </select>
                                        </div>
                                        <div className='col-md-3'>
                                            <label className="form-label">User Role</label><label style={{ color: "red" }}>*</label>


                                            <select
                                                id="userRole"
                                                required
                                                className="form-select"
                                                onChange={(e) => handleCompany(e.target.value)}
                                                value={companyValue}
                                                name="userType"

                                            >
                                                <option value="NA">Choose...</option>
                                                {optionCompany ? optionCompany.map((item, id) => {
                                                    return (
                                                        <option key={id} value={item.value}>
                                                            {" "}
                                                            {item.label}
                                                        </option>
                                                    );
                                                }) : ""}
                                            </select>


                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="State" className="form-label">
                                                State
                                            </label><label style={{ color: "red" }}>*</label>
                                            <MultiSelect
                                                options={optionState}
                                                value={optionState.filter(option => stateValue.includes(option.value))}
                                                // value={selected}
                                                onChange={handleChange}
                                                labelledBy={"Select"}
                                                isCreatable={true}
                                                defaultValue={stateValue} disabled={statelocation ? true : false} />
                                        </div>
                                        {showDistrict === 'show' && <div className="col-md-3">
                                            <label htmlFor="District" className="form-label">
                                                District
                                            </label><label style={{ color: "red" }}>*</label>
                                            <MultiSelect
                                                options={optionDistrict}
                                                value={optionDistrict.filter(option => districtValue.includes(option.value))}
                                                // value={selected}
                                                onChange={handleChangeDistrict}
                                                labelledBy={"Select"}
                                                isCreatable={true}
                                                defaultValue={districtValue} disabled={statelocation ? true : false} />
                                        </div>}
                                        {showSubDistrict === 'show' && <div className="col-md-3">
                                            <label htmlFor="SubDistrict" className="form-label">
                                                Sub District
                                            </label><label style={{ color: "red" }}>*</label>
                                            <MultiSelect
                                                options={optionSubDistrict}
                                                value={optionSubDistrict.filter(option => subdistrictValue.includes(option.value))}
                                                // value={selected}
                                                onChange={handleChangeSubDistrict}
                                                labelledBy={"Select"}
                                                isCreatable={true}
                                                defaultValue={subdistrictValue} disabled={statelocation ? true : false} />
                                        </div>}
                                        {showVillage === 'show' && <div className="col-md-3">
                                            <label htmlFor="Village" className="form-label">
                                                Village
                                            </label><label style={{ color: "red" }}>*</label>
                                            <MultiSelect
                                                options={optionVillage}
                                                value={optionVillage.filter(option => villageValue.includes(option.value))}
                                                onChange={handleChangeVillage}
                                                labelledBy={"Select"}
                                                isCreatable={true}
                                                defaultValue={villageValue} disabled={statelocation ? true : false} />
                                        </div>}



                                        <div className="col-md-3">
                                            <label className="form-label">User Name</label><label style={{ color: "red" }}>*</label>
                                            <input placeholder='User Name' type='text' className='form-control' onChange={(e) => handleUserName(e)} value={userNameValue} maxLength={50} readOnly={statelocation ? true : false} />
                                        </div>

                                        <div className="col-md-3">
                                            <label htmlFor="mobileNo" className="form-label">
                                                Mobile No.
                                            </label><label style={{ color: "red" }}>*</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="mobilenumber"
                                                required
                                                placeholder="Mobile No."
                                                onChange={(e) => handleMobileNumber(e.target.value)}
                                                value={mobileValue}
                                                onKeyUp={validateMobile}
                                                maxLength="10"
                                                readOnly={statelocation ? true : false}

                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Email Id:</label><label style={{ color: "red" }}>*</label>
                                            <input placeholder='Email Id' type='text' id="emailid" className='form-control' onChange={(e) => setEmailValue(e.target.value)} value={emailValue} onKeyUp={validateEmail}
                                                maxLength={50} readOnly={statelocation ? true : false} />
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="Designation" className="form-label">
                                                Designation
                                            </label><label style={{ color: "red" }}>*</label>
                                            <select
                                                id="userDesignation"
                                                required
                                                className="form-select"
                                                onChange={(e) => handleDesignation(e.target.value)}
                                                value={designationValue}
                                                name="userDesignation"

                                            >
                                                <option value="NA">Choose...</option>
                                                {optionDesignaion ? optionDesignaion.map((item, id) => {
                                                    return (
                                                        <option key={id} value={item.desigCode}>
                                                            {" "}
                                                            {item.desigName}
                                                        </option>
                                                    );
                                                }) : ""}
                                            </select>

                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Gender</label><label style={{ color: "red" }}>*</label>
                                            <div className="col-md-12">
                                                <div
                                                    className="form-check form-check-inline"
                                                    onClick={() => {
                                                        setGender("M");
                                                    }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="gender"
                                                        id="inlineRadio1"
                                                        value="male"
                                                        checked={gender === "M" ? "true" : ""}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="inlineRadio1"
                                                    >
                                                        Male
                                                    </label>
                                                </div>
                                                <div
                                                    className="form-check form-check-inline"
                                                    onClick={() => {
                                                        setGender("F");
                                                    }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="gender"
                                                        id="inlineRadio2"
                                                        value="female"
                                                        checked={gender === "F" ? "true" : ""}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="inlineRadio2"
                                                    >
                                                        Female
                                                    </label>
                                                </div>
                                                <div
                                                    className="form-check form-check-inline"
                                                    onClick={() => {
                                                        setGender("T");
                                                    }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="gender"
                                                        id="inlineRadio3"
                                                        value="transgender"
                                                        checked={gender === "T" ? "true" : ""}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="inlineRadio3"
                                                    >
                                                        Transgender
                                                    </label>
                                                </div>
                                            </div>
                                        </div>





                                        <div className="col-md-12 d-flex justify-content-md-center">

                                            <button type="button" className="btn btn-primary me-md-2" onClick={ValidateAddUser} >Submit</button>
                                            <button type="button" className="btn btn-primary me-md-2" onClick={() => navigate("/newadminpanel/userlist")}>Cancel</button>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>


                    </div>
                </section>

            </main>

            <AdminFooterNew />
            {loader === false ? "" : <div class="overlay">
                <div class="overlay__inner">
                    <div class="overlay__content"><span class="spinner"></span></div>
                </div>
            </div>}
        </>
    );
}
export default CompanyLogin